import { makeStyles } from '../../../node_modules/@material-ui/core/styles';
import Image from '../../content/images/login-background.jpg'; 

const useStyles = makeStyles(theme => ({
    background:{
        backgroundImage: `url(${Image})`,
        height: '100%',
        backgroundSize:'100%'
    },
    container: {
        paddingTop: 80,
        paddingRight: 100,
        display: 'flex',
        flexDirection: 'row-reverse'
    },
    paper: {
      marginTop: theme.spacing(-2),
      minWidth: '376px',
      maxWidth: '276px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 20,
      borderRadius:10,
      position: 'absolute',   
      backgroundColor: 'rgba(0, 52, 160, 0.7)',
      color:'white',
      right: theme.spacing(10)
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      }
    }
  }));

  export default useStyles;